import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Carousel, Image } from "antd";
import React, { useEffect } from "react";
import GlobalStoreContext from "../../../context/GlobalStoreContext";
import { Area } from "../../../models/Area";
import { Equipment } from "../../../models/Equipment";
import PlotAPI from "../../../plotAPI";

interface Props {
    currentObject: Area | Equipment;
}

const MapObjectAttachmentsSlider: React.FC<Props> = (props) => {
    const context = React.useContext(GlobalStoreContext);

    const [sliderItems, setSliderItems] = React.useState<React.ReactNode[]>([]);

    useEffect(() => {
        (props.currentObject instanceof Area
            ? PlotAPI.getAreaAttachments(
                  context.currentProjectInfo.claimed_by_team_subdomain || "projects",
                  context.currentProjectInfo.unique_token,
                  props.currentObject.id
              )
            : PlotAPI.getEquipmentAttachments(
                  context.currentProjectInfo.claimed_by_team_subdomain || "projects",
                  context.currentProjectInfo.unique_token,
                  props.currentObject.id
              )
        ).then((attachments) => {
            const newSliderItems: any[] = [];

            for (const attachment of attachments) {
                if (attachment.content_type.startsWith("image")) {
                    newSliderItems.push(
                        <Image
                            key={attachment.id}
                            width={"100%"}
                            height={"100%"}
                            className="rounded-lg!"
                            style={{ objectFit: "contain" }}
                            src={urlForAttachmentImage(attachment)}
                        />
                    );
                }
            }

            if (newSliderItems.length === 0) {
                newSliderItems.push(
                    <Image
                        className="rounded-lg!"
                        key={0}
                        width={"100%"}
                        height={"100%"}
                        style={{ objectFit: "contain" }}
                        src={"/img/png/No-Location-Attachment-Added.png"}
                    />
                );
            }

            setSliderItems(newSliderItems);
        });
    }, [props.currentObject]);

    const urlForAttachmentImage = (attachment: any) => {
        if (props.currentObject instanceof Area) {
            return (
                "/projects/" +
                context.currentProjectInfo.unique_token +
                "/areas/" +
                props.currentObject.id +
                "/areas_attachments/" +
                attachment.id +
                "/picture"
            );
        }

        return (
            "/projects/" +
            context.currentProjectInfo.unique_token +
            "/equipment/" +
            props.currentObject.id +
            "/equipment_attachments/" +
            attachment.id +
            "/picture"
        );
    };

    return (
        <Carousel
            rootClassName="w-full h-full"
            className="w-full h-full"
            arrows={sliderItems.length > 1 ? true : false}
            dots={sliderItems.length > 1 ? true : false}
            prevArrow={<LeftOutlined />}
            nextArrow={<RightOutlined />}
        >
            {sliderItems.map((image) => image)}
        </Carousel>
    );
};

export default MapObjectAttachmentsSlider;
